import * as api from '@/api/domainRegistration'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    CREATE_DOMAIN_CHECK ({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.CREATE_DOMAIN_CHECK(params.domainName).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/domainRegistration.js